// src/scripts/templates/customers/login.js
var selectors = {
  recoverPasswordFormTriggers: "[data-recover-toggle]",
  recoverPasswordForm: "[data-recover-form]",
  loginForm: "[data-login-form]",
  formState: "[data-form-state]",
  resetSuccess: "[data-reset-success]"
};
function onShowHidePasswordForm(evt) {
  evt.preventDefault();
  toggleRecoverPasswordForm();
}
function checkUrlHash() {
  const hash = window.location.hash;
  if (hash === "#recover") {
    toggleRecoverPasswordForm();
  }
}
function toggleRecoverPasswordForm() {
  document.querySelector(selectors.recoverPasswordForm).classList.toggle("hidden");
  document.querySelector(selectors.loginForm).classList.toggle("hidden");
}
function resetPasswordSuccess() {
  if (document.querySelector(selectors.formState)) {
    document.querySelector(selectors.resetSuccess).classList.remove("hidden");
  }
}
if (document.querySelector(selectors.recoverPasswordForm)) {
  checkUrlHash();
  resetPasswordSuccess();
  document.querySelectorAll(selectors.recoverPasswordFormTriggers).forEach((trigger) => {
    trigger.addEventListener("click", onShowHidePasswordForm);
  });
}
